export default function fetchWithTimeout(url, options = {}, timeoutMs = 15000) {
  const controller = new AbortController();
  const { signal, ...restOptions } = options;

  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  return fetch(url, {
    ...restOptions,
    signal: controller.signal,
  }).finally(() => clearTimeout(timeoutId));
}
